import { TOGGLE_SELECT_DEVICE_GROUP } from '../constants/actionTypes';
import { DeviceGroupsActionTypes } from '../types';

export const toggleSelectUnit = (id: string): DeviceGroupsActionTypes => ({
  type: TOGGLE_SELECT_DEVICE_GROUP,
  payload: id,
});
